import type {
  GetAssetPageMarkersProps,
  GetCurrentMarkerProps,
} from "./asset-page-map.type";
import type { AssetMarker } from "@/entities/asset";
import type { LocationDetail } from "@/entities/location";
import type { MapMarker } from "@/modules/map";

import { isSector } from "@/entities/location";
import { parseLatLngString } from "@/modules/map";
import {
  getAssetMarker,
  getLocationMarker,
  getSectorMarker,
  MARKER_ASSET_SCALE,
} from "@/modules/marker";

export const getAssetPageMarkers = ({
  location,
  asset,
  assetColor,
  components,
}: GetAssetPageMarkersProps): MapMarker[] => {
  const locationMarker = getParentMarker(location);
  const assetMarker = getCurrentMarker({
    asset,
    color: assetColor,
    components,
  });

  if (!assetMarker && !locationMarker) return [];

  const assetMarkers = assetMarker ? [assetMarker] : [];

  if (!locationMarker) return assetMarkers;

  return [{ ...locationMarker, children: assetMarkers }];
};

export const getCurrentMarker = ({
  asset,
  color,
  components,
}: GetCurrentMarkerProps) => {
  const position = parseLatLngString({
    coordinate: asset?.coordinate ?? "",
  });

  if (!asset || !position) return null;

  const children = getChildMarkers(components);

  return getAssetMarker({
    model: {
      id: asset.id,
      name: asset.name,
    },
    position,
    color,
    scale: MARKER_ASSET_SCALE.LG,
    children,
  });
};

export const getParentMarker = (location?: LocationDetail) => {
  const position = parseLatLngString({
    coordinate: location?.coordinate ?? "",
  });

  if (!location || !position) return null;

  const { id, name } = location;
  const model = { id, name };

  return isSector(location)
    ? getSectorMarker({ model, position })
    : getLocationMarker({ model, position });
};

export const getChildMarkers = (components: AssetMarker[]) => {
  const markers = components.map((component) =>
    getAssetMarker({
      model: {
        id: component.id,
        name: component.name,
      },
      position: {
        lat: parseFloat(component.lat),
        lng: parseFloat(component.lng),
      },
    })
  );

  return markers.filter((marker) => marker !== null);
};
